export default __webpack_public_path__ + "static/media/hosein-montazer.38a3efc8.png";